import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsAnimatedGrid = () => {
	const { userTags } = useUserTags();

	return userTags.includes(tags.animatedGrid);
};
